export default __webpack_public_path__ + "static/media/master-bg.df538629.webp";